import { addOns, services } from '@/mocks/home';

export default function Services() {
  return (
    <section id="services" className="bg-background-100 scroll-mt-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-24">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">Services &amp; starting prices</h2>
        <p className="mt-3 mb-10 md:mb-14 text-sm md:text-base text-foreground-600">
          Studio / 1 bath. Exact price in the booking form above. <span className="text-accent-600 font-semibold">−10% on your first booking.</span>
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {services.map((s) => (
            <article key={s.id} className={`relative rounded-3xl p-6 md:p-8 flex flex-col ${s.featured ? 'bg-secondary-500' : 'bg-background-50 border border-background-200 shadow-pink'}`}>
              {s.featured && <span className="absolute top-6 right-6 grad-cta text-background-50 text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">Most booked</span>}
              <span className={`w-12 h-12 rounded-2xl text-2xl flex items-center justify-center mb-6 ${s.featured ? 'bg-secondary-600 text-accent-400' : 'bg-primary-50 text-primary-600'}`}><i className={s.icon}></i></span>
              <h3 className={`font-heading font-bold text-xl ${s.featured ? 'text-background-50' : 'text-foreground-950'}`}>{s.title}</h3>
              <p className="mt-2 mb-5 flex items-baseline gap-1.5">
                <span className={`text-sm ${s.featured ? 'text-secondary-200' : 'text-foreground-500'}`}>from</span>
                <span className={`font-heading font-bold text-4xl ${s.featured ? 'text-accent-400' : 'text-primary-700'}`}>${s.price}</span>
              </p>
              <p className={`text-sm md:text-base leading-relaxed flex-1 ${s.featured ? 'text-secondary-100' : 'text-foreground-600'}`}>{s.text}</p>
              <a href="#book" className={`mt-7 text-center font-semibold text-sm py-3 rounded-full whitespace-nowrap cursor-pointer transition-all duration-200 ${s.featured ? 'grad-cta text-background-50 hover:-translate-y-0.5 shadow-pink' : 'bg-primary-50 text-primary-700 hover:bg-primary-100'}`}>Get exact price</a>
            </article>
          ))}
        </div>

        <div className="mt-10 md:mt-14 rounded-3xl bg-background-50 border border-background-200 p-6 md:p-8 shadow-pink">
          <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">Popular add-ons</h3>
          <p className="mt-1 mb-6 text-sm md:text-base text-foreground-600">Add any of these to your cleaning — your exact total shows in the booking form.</p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
            {addOns.map((a) => (
              <li key={a.id} className="flex items-center gap-3 rounded-2xl bg-background-100 border border-background-200 p-4">
                <span className="w-10 h-10 shrink-0 rounded-full bg-primary-50 text-primary-600 text-lg flex items-center justify-center"><i className={a.icon}></i></span>
                <span className="flex-1 text-sm font-medium text-foreground-900 leading-tight">{a.label}</span>
                <span className="font-heading font-bold text-base text-foreground-950">${a.price}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}